"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowInstructionJsonMapper = exports.ShowInstructionDynamoMapper = void 0;
var show_instruction_dynamodb_1 = require("./show-instruction-dynamodb");
Object.defineProperty(exports, "ShowInstructionDynamoMapper", { enumerable: true, get: function () { return show_instruction_dynamodb_1.ShowInstructionDynamoMapper; } });
var show_instruction_json_1 = require("./show-instruction-json");
Object.defineProperty(exports, "ShowInstructionJsonMapper", { enumerable: true, get: function () { return show_instruction_json_1.ShowInstructionJsonMapper; } });
